module.exports = __webpack_public_path__ + "static/media/ballyhoo.75065b36.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/ballyhoo.png
// module id = 297
// module chunks = 0